module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/admin.component.scss
// module id = ./src/app/admin/admin.component.scss
// module chunks = main